var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",class:{ active: _vm.isActive }},[(_vm.isActive)?[_vm._m(0),_c('div',{staticClass:"skeleton-img"})]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-text"},[_c('h2',{staticClass:"skeleton-title"}),_c('p',{staticClass:"skeleton-description"},[_c('span'),_c('span'),_c('span'),_c('span')]),_c('a',{staticClass:"skeleton-link",attrs:{"href":"#"}})])
}]

export { render, staticRenderFns }